export default {
  Language: {
    ru: 'Русский',
    en: 'English',
    fr: 'Français',
  },
  Common: {
    ReturnToShop: 'Retourner à la boutique',
  },
  Brand: {
    Title: 'Paiement de la commande',
    DescriptionLabel: 'Description de la commande',
    Description: 'Paiement de la commande №{{order}}',
    DescriptionNamed: 'Paiement de la commande №{{order}} chez {{merchant}}',
    DateLabel: 'Date de création',
  },
  CardPage: {
    Title: 'Paiement par carte bancaire',
    AmountLabel: 'Montant à payer',
  },
  FormField: {
    CardNumber: 'Numéro de carte',
    CardMonthYear: 'Date d\'expiration',
    CardCVC: 'CVV',
    ShowCvc: 'Afficher le CVV',
    HideCvc: 'Masquer le CVV',
  },
  FormError: {
    Card: {
      pan: {
        required: 'Veuillez remplir le champ',
        invalid: 'Numéro de carte invalide',
      },
      name: {
        required: 'Veuillez remplir le champ',
        invalid: 'Utilisez des lettres latines, espaces, points ou tirets (jusqu\'à 30 caractères)',
      },
      cvc: {
        required: 'Veuillez remplir le champ',
        invalid: 'Veuillez remplir le champ',
      },
      expiry: {
        required: 'Veuillez remplir le champ',
        month: {
          invalid: 'La valeur doit être comprise entre 01 et 12',
        },
        year: {
          invalid: 'Année en cours ou à venir',
        },
      },
    },
  },
  PaymentStatus: {
    Title: {
      complete: 'Paiement réussi',
      partial_complete: 'Paiement partiellement effectué',
      failed: 'Le paiement a échoué',
      pending: 'Vérification du paiement',
    },
    Text: {
      complete: 'Un paiement de {{amount}} a été traité avec succès. Le reçu a été envoyé à votre adresse e-mail.',
      partial_complete: 'Un paiement de {{amount}} n\'a été traité que partiellement. Veuillez contacter la boutique pour plus de détails.',
      failed: 'Nous n\'avons pas pu finaliser le paiement. Réessayez ou contactez la banque émettrice de votre carte',
      pending: 'Cela ne prendra que quelques secondes. Veuillez ne pas fermer la page.',
    },
    AmountLabel: {
      complete: 'Payé',
      partial_complete: 'Payé',
      failed: 'Montant à payer',
      pending: 'Montant à payer',
    },
  },
  Action: {
    Pay: 'Payer',
    Retry: 'Réessayer le paiement',
  },
  FatalError: {
    SomethingWentWrong: 'Une erreur est survenue.',
    Code: {
      NO_TERMINALS_AVAILABLE: 'Aucun terminal disponible pour ce mode de paiement.',
      FORM_PAY_ALREADY_SUBMITED: 'Veuillez retourner à la boutique pour réessayer le paiement.',
      FORM_PAY_ALREADY_SUBMITTED: 'Veuillez retourner à la boutique pour réessayer le paiement.',
      COMMON_ERROR: 'Erreur lors du traitement du paiement.',
      DUPLICATE_ORDER_ERROR: 'Une commande avec ce numéro existe déjà.',
      ROUTE_ERROR: 'Ce paiement ne peut pas être traité pour le moment.',
    },
  },
}
